import { render, staticRenderFns } from "./RecipeEditIngredients.vue?vue&type=template&id=7c8f06f2&scoped=true"
import script from "./RecipeEditIngredients.vue?vue&type=script&lang=js"
export * from "./RecipeEditIngredients.vue?vue&type=script&lang=js"
import style0 from "./RecipeEditIngredients.vue?vue&type=style&index=0&id=7c8f06f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f06f2",
  null
  
)

export default component.exports